import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import OTIcon from '../tag/OTIcon';
import WindowUtils from '../../utils/WindowUtils';
import { BIOBANK, USER } from '../../data/reducer';
import {
  doGetConsentStatus,
  doGetDocumentContent,
  doUpdateConsent,
  resetDocumentContent,
  updateBioBankAgreement,
} from '../../data/biobank/actions';
import { hasConsent, pdfCallback, printPdf } from '../../utils/BioBankUtil';
import Loader from '../Loader';
import ExpandHOC from '../ExpandHOC';
import BioBankHeader from './BioBankHeader';
import { ConsentDocument } from './ConsentDocument';
import BioBankVersionMismatchModal from './BioBankVersionMismatchModal';
import Alert from '../Alert';
import { withRouter } from 'react-router-dom';
import { formatDate } from '../../utils/TimeUtils';
import OTButtonGroup from '../tag/OTButtonGroup';
import OTButton from '../tag/OTButton';

var moment = require('moment');
const { id: module_id } = module;

const BioBankPage1Summary = ExpandHOC(
  ({ data, setRef, toggleOpen, isOpen, isDisplayNone, maxHeight }) => {
    let style = isDisplayNone ? { display: 'none' } : {};
    let { attachments } = data;
    let { text } = attachments[0];
    style.maxHeight = isOpen ? maxHeight : 0;
    style.opacity = isOpen ? 1 : 0;

    return (
      <div>
        <div style={style} ref={setRef} className="expand">
          <div dangerouslySetInnerHTML={{ __html: text }} />
        </div>
        <OTButtonGroup>
          <OTButton className={'showmore'} onClick={toggleOpen}>
            <FormattedMessage
              id={isOpen ? 'hide.biobank.agreement' : 'show.biobank.agreement'}
            />{' '}
            <OTIcon
              config={{
                type: 'fa',
                name: `icon-chevron-${isOpen ? 'up' : 'down'}`,
              }}
            />
          </OTButton>
        </OTButtonGroup>
      </div>
    );
  }
);

class BioBankAgreement2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      agreement: false,
      edit: props.match.params.version !== 'current',
      error: null,
      versionMismatchModal: {
        status: 'HIDE', // HIDE | SHOW | ERROR
        latestDocumentVersion: null,
      },
    };
  }

  componentDidMount() {
    let {
      consentData,
      doGetDocumentContent,
      match: {
        params: { version },
      },
    } = this.props;

    if (
      consentData.data &&
      consentData.data.status === 'REFUSAL' &&
      version === 'current'
    )
      throw 'Invalid path';

    let context = version === 'current' ? 'currentConsent' : 'latestConsent';
    let documentVersion = version === 'current' ? consentData.version : null;

    doGetDocumentContent(context, 'CONSENT', documentVersion).then(() => {
      this.initForm(this.props);
    });
  }

  componentWillUnmount() {
    let { resetDocumentContent } = this.props;
    resetDocumentContent('currentConsent');
    resetDocumentContent('latestConsent');
  }

  initForm = (props) => {
    if (hasConsent(props.consentData)) {
      this.agree(true);
    } else {
      this.setState({ edit: true });
    }
  };

  agree = (val) => {
    this.setState({ agreement: val });
  };

  startEdit = () => {
    // check new version
    let { consentData, match } = this.props;
    if (
      match.params.version === 'current' &&
      consentData.version !== consentData.latestVersion
    ) {
      //version is different. show check modal
      this.setState({
        versionMismatchModal: {
          status: 'SHOW',
          latestDocumentVersion: consentData.latestVersion,
        },
      });
    } else {
      this.setState({ edit: true });
    }
  };

  back = () => {
    let { history, match } = this.props;
    history.push(`/biobank/consent/${match.params.version}/1`);
  };

  printPdf = () => {
    let { consentData, intl } = this.props;
    printPdf(
      'Biopankki_suostumus.pdf',
      'biopankkiPrintContainer',
      pdfCallback(
        {
          version: consentData.version,
          date: formatDate(consentData.versionApproved),
          type: 'consent',
        },
        intl
      )
    );
  };

  handleVersionMismatchModalClick = (action) => {
    let { history } = this.props;

    if (action === 'cancel') {
      WindowUtils.navigate('#/biobank/');
    } else if (action === 'next') {
      this.props
        .doGetDocumentContent('latestConsent', 'CONSENT', null)
        .then(() => {
          history.push('/biobank/consent/latest/1');
        })
        .catch(() => {
          this.setState({
            versionMismatchModal: {
              ...this.state.versionMismatchModal,
              status: 'ERROR',
            },
          });
        });
    }
  };

  next = (incidentalValue, recontactValue, version) => {
    let {
      userInfo,
      doUpdateConsent,
      doGetConsentStatus,
      updateBioBankAgreement,
    } = this.props;

    let data = {
      consentType: 'OPT-IN',
      documentType: 'CONSENT',
      incidental: incidentalValue,
      recontact: recontactValue,
      language: 'FIN',
      version: version,
    };
    doUpdateConsent(data)
      .then(() => {
        doGetConsentStatus(userInfo.data.hetu).then(updateBioBankAgreement(true));

        WindowUtils.navigate('#/biobank/');
      })
      .catch(() => {
        this.setState({ error: true });
      });
  };

  render() {
    let { edit, error } = this.state;
    let {
      userInfo,
      documentContent: { data, status },
      consentData,
      agreement,
      match,
    } = this.props;

    if (status === 'ERROR')
      return <Alert message={`${module_id}.error.fetching.consent`} />;

    if (!consentData || !data || status === 'LOADING') return <Loader />;

    return (
      <div className="biobank">
        <div className="biobank_agreement_content_title">
          <BioBankHeader>2/2</BioBankHeader>
        </div>
        <div className="biobank_agreement_content_container">
          <div className="biobank_agreement_content_container_part1">
            <FormattedMessage id={`biobank.agreement.part1.title`}>
              {(txt) => <p>{txt}</p>}
            </FormattedMessage>
            {agreement && (
              <span style={{ marginLeft: '20px' }} className="biobank_green">
                <i className="icon-ok" style={{ marginRight: '10px' }} />
                <FormattedMessage id={`read`} />
              </span>
            )}
            <BioBankPage1Summary data={data} />
          </div>
          <ConsentDocument
            context={match.params.version}
            userInfo={userInfo.data}
            consentData={consentData}
            documentContentData={data}
            error={error}
            edit={edit}
            startEdit={this.startEdit}
            agreement={agreement}
            back={this.back}
            next={this.next}
            printPdf={this.printPdf}
          />
        </div>
        {this.state.versionMismatchModal.status && (
          <BioBankVersionMismatchModal
            status={this.state.versionMismatchModal.status}
            isOpen={this.state.versionMismatchModal.status !== 'HIDE'}
            latestDocumentVersion={
              this.state.versionMismatchModal.latestDocumentVersion
            }
            closeModal={this.handleVersionMismatchModalClick}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    documentContent:
      ownProps.match.params.version === 'current'
        ? state[BIOBANK].consentDocumentContent
        : state[BIOBANK].latestConsentDocumentContent,
    consentData: state[BIOBANK].consentData.data,
    userInfo: state[USER].userInfo,
    relatives: state[USER].relatives,
  };
};

export default injectIntl(
  withRouter(
    connect(mapStateToProps, {
      resetDocumentContent,
      doUpdateConsent,
      doGetConsentStatus,
      doGetDocumentContent,
      updateBioBankAgreement,
    })(BioBankAgreement2)
  )
);
